import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=5b33f8d0&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"
import style0 from "./Cases.vue?vue&type=style&index=0&id=5b33f8d0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33f8d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b33f8d0')) {
      api.createRecord('5b33f8d0', component.options)
    } else {
      api.reload('5b33f8d0', component.options)
    }
    module.hot.accept("./Cases.vue?vue&type=template&id=5b33f8d0&scoped=true", function () {
      api.rerender('5b33f8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/investment-research/components/Cases.vue"
export default component.exports